var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGroupIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.85 5.705a2.906 2.906 0 1 0-3.19 0 3.744 3.744 0 0 0-2.14 3.38v3.735a.83.83 0 1 0 1.66 0V9.085a2.075 2.075 0 1 1 4.15 0v3.735a.83.83 0 1 0 1.66 0V9.085c0-1.494-.88-2.782-2.14-3.38Zm-1.6-3.676c.69 0 1.25.558 1.25 1.245a1.245 1.245 0 1 1-1.25-1.245Zm10.73 3.676a2.906 2.906 0 1 0-3.19 0 3.744 3.744 0 0 0-2.14 3.38v3.735a.83.83 0 1 0 1.66 0V9.085a2.075 2.075 0 1 1 4.15 0v3.735a.83.83 0 1 0 1.66 0V9.085c0-1.494-.88-2.782-2.14-3.38Zm-.35-2.431a1.246 1.246 0 1 0-1.25 1.245c.69 0 1.25-.557 1.25-1.245Z",
  fill: "currentColor"
})));
export { SvgGroupIcon as ReactComponent };
export default __webpack_public_path__ + "images/group-icon.svg";